import { Navigate } from 'react-router-dom';

const DashboardPage = () => {
  return <Navigate to="/dashboard/map" replace />;
};

export default DashboardPage;
